// Generated by Melange

import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__NavbarDropdownItems from "./NavbarDropdownItems.js";
import * as Buhta_landing__NavbarMainItems from "./NavbarMainItems.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function NavbarMenuMobile(Props) {
  let menus = Props.menus;
  let setMobileMenuActive = Props.setMobileMenuActive;
  const intl = ReactIntl.useIntl();
  const match = React.useState(function () {
    return -1;
  });
  const setIdx = match[1];
  const idx = match[0];
  const countryEnum = Buhta_models__Locale.toCountryString(Buhta_landing__Route.getCountry(undefined));
  const allItems = Stdlib__List.append(menus, {
    hd: {
      type_: "link",
      name: Buhta_landing__I18n.trans(intl, "help"),
      menu_items: /* [] */ 0,
      link: undefined,
      country: countryEnum,
      order: 5
    },
    tl: /* [] */ 0
  });
  const activeItem = idx < 0 ? undefined : Stdlib__List.nth(allItems, idx);
  const menuPadding = idx < 0 ? "pt-4" : "pt-0";
  return JsxRuntime.jsx("div", {
    children: activeItem !== undefined ? JsxRuntime.jsx(Buhta_landing__NavbarDropdownItems.make, {
        item: activeItem,
        setIdx: setIdx,
        setMobileMenuActive: setMobileMenuActive
      }) : JsxRuntime.jsx(Buhta_landing__NavbarMainItems.make, {
        menus: allItems,
        setIdx: setIdx,
        setMobileMenuActive: setMobileMenuActive
      }),
    className: "fixed top-26 bottom-0 w-screen bg-white " + menuPadding + " px-6 overflow-y-scroll z-10"
  });
}

const make = NavbarMenuMobile;

export {
  make,
}
/* Buhta_landing__NavbarDropdownItems Not a pure module */
